import MedicationChangeInfo from './MedicationChangeInfo';

export default MedicationChangeInfo;
